export default __webpack_public_path__ + "static/media/cil_02-1.88ccf69c.jpg";